import { TableRows } from 'ui/tableRows';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { BlockTableWrapper, StyledTable, StyledTableHeader } from './BlocksTable.styles';
import { BlockTableEmptyState } from './BlockTableEmptyState';
import { useTableState } from './useTableState';

export const DATA_TEST = {
  table: 'mi-block-table',
};

export const BlocksTable = () => {
  const { rows, columns, isEmpty, isLoading, loadingRows } = useTableState();
  const {
    sortedBy,
    setSortedBy,
    sortDirection,
    setSortDirection,
    rows: tableRows,
  } = useClientPaginatedState({
    rows,
    sortedBy: 'updated',
    isPaginated: false,
  });

  if (isEmpty) {
    return <BlockTableEmptyState />;
  }

  return (
    <BlockTableWrapper>
      <StyledTable data-test={DATA_TEST.table}>
        <StyledTableHeader
          columns={columns}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
        />
        <TableRows
          rows={isLoading ? loadingRows : tableRows}
          idKey="block-table-row"
          columns={columns}
        />
      </StyledTable>
    </BlockTableWrapper>
  );
};
